import { Component, OnInit } from '@angular/core';
import { RegistrationService } from '../../registration.service';

import { FormGroup, FormControl, NgForm } from '@angular/forms';
import { forEach } from '@angular/router/src/utils/collection';
import swal from 'sweetalert2'
import { Observable } from 'rxjs/Observable';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { HandleError } from '../../shared/HandleError';

@Component({
  selector: 'app-form1',
  templateUrl: './form1.component.html',
  styleUrls: ['./form1.component.css']
})
export class Form1Component implements OnInit {
  RankLevels: any;
  SD_Qualifictaion_errormessage: string;
  Districts: any;
  Taluks: any;
  Villages: any;
  States: any;
  OccupationTypes: any;
  Relations: any;
  Castes: any;
  Relegions: any;
  ServiceTypes: any;
  CivilTypes: any;
  Qualifications: any;
  Corps: any;
  Ranks: any;
  config: { heroesUrl: any; textfile: any; };
  title = "Data Entry";
  data;
  sainikDetails: any;
  // service = new RegistrationService();
  // service: RegistrationService;
  fingerprintimageUrl: string = "assets/images/image-default.png";
  signatureimageUrl: string = "assets/images/image-default.png";
  photoimageUrl: string = "assets/images/image-default.png";
  fileToUpload: File = null;
  s: any = {};
  SainikPension: any = {};
  formInvalid: boolean = false;

  options = [
    { id: 1, name: 'One' },
    { id: 2, name: 'Two' },
    { id: 3, name: 'Three' },
  ];
  filteredOptions = this.options;
  constructor(private service: RegistrationService,private handleError:HandleError) {
  }

  ngOnInit() {
    this.GetAllRanks();
    this.GetAllCorps();
    this.GetAllQualifications();
    this.GetAllCivilTypes();
    this.GetAllServiceTypes();
    this.GetAllRelegions();
    this.GetAllCaste();
    this.GetAllRelations();
    this.GetAllOccupationTypes();

    this.GetStates();
    // this.GetDistricts();
    //this.GetTaluks();
    // this.GetVillages();
    //swal({title: 'Success',text: 'Do you want to continue',type: 'success',customClass: 'swal-wide',confirmButtonText: 'Cool'})   
  }

  speedSearchFilter(val: string) {
    this.filteredOptions = this.options.filter(option => option.name.toLowerCase().indexOf(val.toLowerCase()) === 0)
  }

  //photo
  PhotoFileInput(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png)$/;
    this.fileToUpload = file.item(0);
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
    if (uploadedFilename.match(redexe)){
      swal('Warning!', "File type .exe is not allowed", 'warning');
      this.s.SR_Photo="";
      return true;
    }
    //show image preview
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.photoimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.service.uploadImage(data);
    x.subscribe(
      (response) => {

        console.log(response);
      }, (error: any) => {
        // this.SR_Photo_errormessage=error.Message;
        this.SR_Photo_errormessage = "error";
      });
    }
    else {
      let i: any = document.getElementById('SR_Photo');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload Image file with extension.jpeg,jpg or png", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getImage() {
    let imagename = null;
    try {
      imagename = document.getElementById('SR_Photo');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  FingerPrintFileInput(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png)$/;
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
    if (uploadedFilename.match(redexe)){
      swal('Warning!', "File type .exe is not allowed", 'warning');
      this.s.SR_FingerPrint="";
      return true;
    }

    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
    reader.onload = (event: any) => {
      this.fingerprintimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.service.uploadImage(data);
    x.subscribe(
      (response) => {
        console.log(response);
      }, (error) => {
        console.log(error);
      });
    }
    else {
      let i: any = document.getElementById('SR_FingerPrint');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload Image file with extension.jpeg,jpg or png", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getFingerPrintImage() {
    let imagename = null;
    try {
      imagename = document.getElementById('SR_FingerPrint');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  signatureFileInput(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png)$/;
    this.fileToUpload = file.item(0);
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
    if (uploadedFilename.match(redexe)){
      swal('Warning!', "File type .exe is not allowed", 'warning');
      this.s.SR_Signature="";
      return true;
    }
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.signatureimageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.service.uploadImage(data);
    x.subscribe(
      (response) => {
        console.log(response);
      }, (error) => {
        console.log(error);
      });
    }
    else {
      let i: any = document.getElementById('SR_Signature');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload Image file with extension.jpeg,jpg or png", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getSignatureImage() {
    let imagename = null;
    try {
      imagename = document.getElementById('SR_Signature');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  CheckSainikExist(SR_ServiceNo){
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.checkSainikExist(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        console.log(error);
        //if (error.Message == "")
        //if(error.status==400)
        swal("Warning!", "Service number already exist", "warning");
       
      });
  }


  submitme(f: NgForm) {
    if (f.valid) {
      this.formInvalid = false;
      document.getElementById('loader-spinner').style.display = "block";
      f.value.SR_Photo = this.getImage();
      f.value.SR_FingerPrint = this.getFingerPrintImage();
      f.value.SR_Signature = this.getSignatureImage();
      f.value.SainikDependents = this.FamilyDetails;
      f.value.SainikPenison = {
        SP_Gratuity: f.value.SP_Gratuity,
        SP_GroupInsurance: f.value.SP_GroupInsurance,
        SP_ServicePension: f.value.SP_ServicePension,
        SP_DisabilityPension: f.value.SP_DisabilityPension,
        SP_PercentageOfDisability: f.value.SP_PercentageOfDisability,
        SP_LeaveEncashment: f.value.SP_LeaveEncashment,
        SP_FinancialAssistance: f.value.SP_FinancialAssistance,
        SP_CommutedPension: f.value.SP_CommutedPension,
        SP_DischargeBookNo: f.value.SP_DischargeBookNo,
        SP_DischargeBookDate: f.value.SP_DischargeBookDate,
        SP_PPONo: f.value.SP_PPONo,
        SP_PPODate: f.value.SP_PPODate
      };
      f.value.SR_PA_Pincode = this.s.SR_PA_Pincode;

      this.data = this.service.doregister(f.value);
      this.data.subscribe(
        (response) => {
          console.log(f)
          f.reset();
          f.resetForm();
          f.form.markAsPristine();
          f.form.markAsUntouched();
          this.fingerprintimageUrl = "assets/images/image-default.png";
          this.signatureimageUrl = "assets/images/image-default.png";
          this.photoimageUrl = "assets/images/image-default.png";
          this.FamilyDetails = [];
          this.formInvalid = false;
          swal('Success!', 'Sainik details saved successfully.', 'success');
          document.getElementById('loader-spinner').style.display = "none";
          // window.location.href='http://sainik.esdinfra.com/index.html#/';
        }, (error) => {
          console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
          // if(error.status == 401)
          // swal('Warning!', 'Not authorized to access this page.', 'warning');
          this.handleError.ErrorHandler(error);
        });
    }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }


  FamilyDetails = [];
  SD_Name_errormessage = "";
  SD_DOB_errormessage = "";
  SD_Relation_errormessage = "";
  SR_Photo_errormessage = "";
  fd:any={};

  AddFamily(fd) {
    if (this.checkAllFamilyValidation(fd)) {
      let temp = {
        SD_Name: fd.SD_Name,
        SD_DOB: fd.SD_DOB,
        SD_Relation: fd.SD_Relation.Relation_Id,
        relationName: fd.SD_Relation.Relation_Name,
        SD_Qualification: fd.SD_Qualifictaion.Q_Id,
        qualificationName: fd.SD_Qualifictaion.Q_Name,
      //  SD_Qualification: fd.SD_Qualifictaion,
        SD_Email: fd.SD_Email,
        SD_AdharCard: fd.SD_AdharCard
      }
      this.FamilyDetails.push(temp);
      this.fd = {};
      this.SD_Relation_errormessage = "";
    }
  }
  

  ClearRank(){
    this.s.SR_Rank="";
   // this.s.SR_RankLevel={};
  }



CheckRequired(value) {
  if (typeof (value) != undefined && value != '' && value != null)
    return true;
  else
    return false;
}

Removefamily(i) {
  this.FamilyDetails.splice(i, 1);
}

GetSainikDetails(SR_ServiceNo) {
  this.sainikDetails="";
  this.data = this.service.getSainikDetails(SR_ServiceNo);
  this.data.subscribe(
    (response) => {
      this.sainikDetails = response;
    }, (error) => {
      console.log(error);
    });
}

GetAllRanks() {
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.service.getAllRanks();
  this.data.subscribe(
    (response) => {
      this.Ranks = response;
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      document.getElementById('loader-spinner').style.display = "none";
      console.log(error);
    });
}

GetAllCorps() {
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.service.getAllCorps();
  this.data.subscribe(
    (response) => {
      this.Corps = response;
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      console.log(error);
      document.getElementById('loader-spinner').style.display = "none";
    });
}

GetRankLevels(SR_Corps,SR_Rank){
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.service.getRankLevels(SR_Corps,SR_Rank,"undefined");
  this.data.subscribe(
    (response) => {
      this.RankLevels = response;
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      console.log(error);
      document.getElementById('loader-spinner').style.display = "none";
    });
}

GetAllQualifications() {
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.service.getAllQualification();
  this.data.subscribe(
    (response) => {
      this.Qualifications = response;
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      console.log(error);
      document.getElementById('loader-spinner').style.display = "none";
    });
}

GetAllCivilTypes() {
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.service.getAllCivilTypes();
  this.data.subscribe(
    (response) => {
      this.CivilTypes = response;
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      console.log(error);
      document.getElementById('loader-spinner').style.display = "none";
    });
}
GetAllServiceTypes() {
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.service.getAllServiceTypes();
  this.data.subscribe(
    (response) => {
      this.ServiceTypes = response;
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      console.log(error);
      document.getElementById('loader-spinner').style.display = "none";
    });
}

GetAllRelegions() {
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.service.getAllRelegions();
  this.data.subscribe(
    (response) => {
      this.Relegions = response;
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      console.log(error);
      document.getElementById('loader-spinner').style.display = "none";
    });
}

GetAllCaste() {
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.service.getAllCaste();
  this.data.subscribe(
    (response) => {
      this.Castes = response;
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      console.log(error);
      document.getElementById('loader-spinner').style.display = "none";
    });
}

GetAllRelations() {
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.service.getAllRelations();
  this.data.subscribe(
    (response) => {
      this.Relations = response;
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      console.log(error);
      document.getElementById('loader-spinner').style.display = "none";
    });
}

GetAllOccupationTypes() {
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.service.getAllOccupationTypes();
  this.data.subscribe(
    (response) => {
      this.OccupationTypes = response;
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      console.log(error);
      document.getElementById('loader-spinner').style.display = "none";
    });
}

GetAllStates(enteredText: any) {
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.service.getAllStates(enteredText);
  this.data.subscribe(
    (response) => {
      this.States = response;
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      console.log(error);
      document.getElementById('loader-spinner').style.display = "none";
    });
}

GetAllDistricts(enteredText: any) {
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.service.getAllDistricts(enteredText);
  this.data.subscribe(
    (response) => {
      this.Districts = response;
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      console.log(error);
      document.getElementById('loader-spinner').style.display = "none";
    });
}

GetAllTaluks(enteredText: any) {
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.service.getAllTaluks(enteredText);
  this.data.subscribe(
    (response) => {
      this.Taluks = response;
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      console.log(error);
      document.getElementById('loader-spinner').style.display = "none";
    });
}

GetAllVillages(enteredText: any) {
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.service.getAllVillages(enteredText);
  this.data.subscribe(
    (response) => {
      this.Villages = response;
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      console.log(error);
      document.getElementById('loader-spinner').style.display = "none";
    });
}

//
GetStates() {
  document.getElementById('loader-spinner').style.display = "block";
  this.data = this.service.getStates();
  this.data.subscribe(
    (response) => {
      this.States = response;
      document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      console.log(error);
      document.getElementById('loader-spinner').style.display = "none";
    });
}

GetDistricts(stateId) {
  if (stateId != undefined) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getDistricts(stateId);
    this.data.subscribe(
      (response) => {
        this.Districts = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  else {
    this.s.SR_PA_District = undefined;
  }
}

GetTaluks(districtId) {
  if (districtId != undefined) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getTaluks(districtId);
    this.data.subscribe(
      (response) => {
        this.Taluks = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  else {
    this.s.SR_PA_District = undefined;
    this.s.SR_PA_Mandal = undefined;
  }
}

GetVillages(talukId) {
  if (talukId != undefined) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getVillages(talukId);
    this.data.subscribe(
      (response) => {
        this.Villages = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  else {
    this.s.SR_PA_District = undefined;
    this.s.SR_PA_Mandal = undefined;
    this.s.SR_PA_Village = undefined;
  }
}

GetPincode(villageId: number) {
  for (let i = 0; i <= this.Villages.length; i++) {
    if (villageId == this.Villages[i].VI_Id)
      this.s.SR_PA_Pincode = this.Villages[i].VI_PinCode;
  }
}


//
//*********validation********** */
checkAllFamilyValidation(fd: any) {
  let result1 = this.CheckFamilyName(fd.SD_Name);
  let result2 = this.CheckFamilyDOB(fd.SD_DOB);
  let result3 = this.CheckFamilyRelation(fd.SD_Relation);
  let result4 = this.CheckFamilyQualification(fd.SD_Qualifictaion);

  if (result1 && result2 && result3 && result4)
    return true;
  else
    return false;
}

CheckFamilyName(name) {
  if (this.CheckRequired(name)) {
    this.SD_Name_errormessage = "";
    return true;
  }
  else {
    this.SD_Name_errormessage = "Please enter name";
    return false;
  }
}

CheckFamilyDOB(dob) {
  if (this.CheckRequired(dob)) {
    this.SD_DOB_errormessage = "";
    return true;
  }
  else {
    this.SD_DOB_errormessage = "Please enter DOB";
    return false;
  }
}

CheckFamilyRelation(relation) {
  if (this.CheckRequired(relation)) {
    this.SD_Relation_errormessage = "";
    return true;
  }
  else {
    this.SD_Relation_errormessage = "Please enter relation";
    return false;
  }
}

CheckFamilyQualification(qualification) {
  if (this.CheckRequired(qualification)) {
    this.SD_Qualifictaion_errormessage = "";
    return true;
  }
  else {
    this.SD_Qualifictaion_errormessage = "Please select qualification";
    return false;
  }
}
}



// WEBPACK FOOTER //
// ./src/app/forms/form1/form1.component.ts